const getSubdomain = () => {
  const parts = window.location.hostname.split(".");
  if (parts.length > 2) {
    return parts.slice(0, parts.length - 2).join(".");
  }
  return "";
};

const config = {
  passCardTerminology: getSubdomain() === "ciu" ? "passCard" : "membershipId",
  apiBaseUrl: `https://${getSubdomain() || "staging"}.mygamesaccess.com/api`,
  sentryDsn:
    "https://35b695d64e5360b416e841d07f7daa1b@o4508711257178112.ingest.de.sentry.io/4509162709319760",
};

export default config;
